import { createContext, useContext, type ReactNode } from "react";

interface FormDisplay {
    /** Hide the "(optional)" suffix on optional questions. The question stays optional. */
    hideRequiredMarker: boolean;
}

const FormDisplayContext = createContext<FormDisplay>({ hideRequiredMarker: false });

/** Per-form display switches (forms.show_required_marker) for the questions inside it. */
export function FormDisplayProvider({ hideRequiredMarker, children }: FormDisplay & { children: ReactNode }) {
    return <FormDisplayContext.Provider value={{ hideRequiredMarker }}>{children}</FormDisplayContext.Provider>;
}

/** Muted "(optional)" after an optional question label (GOV.UK style). Hidden when the form turns it off. */
export function OptionalMark() {
    const { hideRequiredMarker } = useContext(FormDisplayContext);
    if (hideRequiredMarker) return null;
    return <span className="ml-1 font-normal text-muted-foreground">(optional)</span>;
}
